import {
    ID_FILTER_PREVIEW_INTERMEDIARY,
    ID_FILTER_PRINTOUT_CREATIONDATEFROM,
    ID_FILTER_PRINTOUT_CREATIONDATETO,
    ID_FILTER_PRINTOUT_INTERMEDIARY,
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_DEALERS
} from "../../pages/intermediaries/constants/IntermediariesFilters";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";
import qs from "qs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useIntermediariesPrintoutRepository = () => {

    const { GET, PUT, DELETE } = useApi();

    const PATH = "/finance/intermediaries"
    
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
    
    async function getIntermediaries(legalEntity: string, dealer: string) {
        let params = {
            legalEntity: [legalEntity],
            dealer: [dealer],
        }

        return await GET(`${PATH}/intermediary/search`, {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, true);
    }

    function getPrintoutsOfReport( filterDefs: FilterDef[] = [], id: any | null): Promise<HTTPGenericResponse> {
        let intermediary = getFilterValue(ID_FILTER_PREVIEW_INTERMEDIARY, filterDefs);

        let params = {
            intermediaryName: intermediary,
            legalEntities: allLegalEntities
        }
        return GET(`${PATH}/intermediaryPrintout?reportId=`+id, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }

    function getPrintouts(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = [], id: any | null): Promise<HTTPGenericResponse> {
        let creationDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATETO, filterDefs);
        let intermediary = getFilterValue(ID_FILTER_PRINTOUT_INTERMEDIARY, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            reportCreationDateFrom: creationDateFrom ? dayjs(creationDateFrom).toISOString() : null,
            reportCreationDateTo: creationDateTo ? dayjs(creationDateTo).toISOString() : null,
            intermediaryName: intermediary,
            legalEntities,
            dealers
        }
        return GET(`${PATH}/intermediaryPrintout`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function downloadPrintoutCSV(reportId: string): Promise<HTTPGenericResponse> {
        let params = {
            reportId: reportId,
            legalEntities: allLegalEntities
        }

        return GET(`${PATH}/intermediaryPrintout/download/report`, { params: params,  paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "repeat", skipNulls: true })}, true);
    }

    function downloadPrintoutHTML(reportId: string, intermediaryId: string) {
        let params = {
            id: reportId,
            intermediaryId: intermediaryId,
            legalEntities: allLegalEntities
        }
        return GET(`${PATH}/intermediaryPrintout/download/printout/html`, { params: params,  paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "repeat", skipNulls: true })}, true);
    }

    function publishIntermediaryPrintouts(ids: string[]): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/intermediaryPrintout/publish`, ids, {}, true);
    }

    function downloadPrintoutPdf(reportId: string, intermediaryId: string) {
        let params = {
            id: reportId,
            intermediaryId: intermediaryId,
            legalEntities: allLegalEntities
        }
        return GET(`${PATH}/intermediaryPrintout/download/printout/pdf`, { params: params,  paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "repeat", skipNulls: true })}, true);
    }


    function deleteIntermediaryPrintout(id: string) {
        let params = { id: id }
        return DELETE(`${PATH}/intermediaryPrintout`, {params: params}, true);
    }

    function deleteIntermediaryPrintoutItem(id: string) {
        let params = { id: id }
        return DELETE(`${PATH}/intermediaryPrintout/item`, {params: params}, true);
    }
    return {
        getIntermediaries,
        getPrintoutsOfReport,
        getPrintouts,
        downloadPrintoutCSV,
        publishIntermediaryPrintouts,
        downloadPrintoutHTML,
        downloadPrintoutPdf,
        deleteIntermediaryPrintout,
        deleteIntermediaryPrintoutItem
    };
}